// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uEUC","footer":"styles_footer__2t63E"};